<template>
    <!--Groups Dialog -->
    <!--Emits a 'close' event - so to close, must include @close="activeeditdialog=false"-->
    <!--THIS CARD NEEDS TO REMAIN THE TOP LEVEL TAG HERE;
    IT OPENS IN A PAGE OR A DIALOG. DO NOT ENCLOSE IN ANOTHER TAG-->
        <v-card>
            <v-card-title>
                <span v-if="groupstatus==='groups'" class="mx-2 success--text">
                    Active Groups
                </span>
                <span class="mx-2 warning--text" v-else >
                    Archived Groups
                </span>
                <v-spacer></v-spacer>
                <v-btn icon  @click="closedialog()" v-if="closebutton">
                    <v-icon>{{$store.state.icons.close}}</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <GroupList :callback="editGroup" :icon="$store.state.icons.edit"  :checks="checks"  />
                <GroupCard v-if="selectedgroup" :group="selectedgroup" :dialog="editgroup" @close="editgroup=false" />
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="closedialog()"  v-if="closebutton">
                    <v-icon class="mr-2">{{$store.state.icons.close}}</v-icon>
                    <span class="hidden-xs-only">
                        Close
                    </span>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="success elevation-0" small tile @click="getAllActive" :disabled="groupstatus==='groups'" :loading="loading2" >Active</v-btn>
                <v-btn color="warning elevation-0" small tile @click="getAllArchived" :disabled="groupstatus==='archivedgroups'" :loading="loading1">Archived</v-btn>
                <v-spacer></v-spacer>
                <NewGroup />
            </v-card-actions>
        </v-card>

</template>

<script>
  import {
    mapState,
    mapMutations,
    mapActions
  } from 'vuex'
  import NewGroup from "@/components/groups/NewGroup";
  import GroupCard from "@/components/groups/GroupCard";
  import GroupList from "@/components/groups/GroupList";
  export default {
    components: { GroupList, GroupCard, NewGroup},
    name: "GroupActions",
    props:{
      checks:{
        type: Boolean,
        default: false
      },
      closebutton:{
        type:Boolean,
        default:false
      }
    },
    data() {
      return {
        selectedgroup:undefined,
        editgroup:false,
        loading:false,
        loading1:false,
        loading2:false
      }
    },
    mounted() {
      //this.showactive = (Object.keys(this.$store.state.groups)[0].archived)?false:true
      if(this.$store.state.activegroup){
        this.selectedgroup = this.$store.state.activegroup
        this.editgroup = this.$store.state.activegroup
      }
    },
    computed:{
      ...mapState(['groupstatus'])
    },
    watch: {

    },
    methods: {
      ...mapMutations(['activeGroupStatus']),
      ...mapActions(['getAllActiveGroups','getAllArchivedGroups']),
      closedialog(){
        this.loading=false;
        this.$emit('close',false)
      },
      async editGroup(g){
        console.log(g)
        let f = await this.$store.dispatch('getGroup',g.groupkey);
        this.selectedgroup = f.Item;
        this.editgroup=true;
      },

      getAllActive(){
        this.activeGroupStatus('groups')
        this.loading2=true
        this.getAllActiveGroups()
        this.loading2=false
      },

      getAllArchived () {
        this.activeGroupStatus('archivedgroups')
        this.loading1=true
        this.getAllArchivedGroups()
        this.loading1=false
      }
    }
  }
</script>

<style scoped>

</style>